require('./components/LegacyReactTemplates/listAccounts.jsx');
require('./components/LegacyReactTemplates/listAppointment.jsx');
require('./components/LegacyReactTemplates/listSoliditet.jsx');
require('./components/LegacyReactTemplates/listOrders.jsx');
require('./components/LegacyReactTemplates/viewPicker.jsx');
require('./components/LegacyReactTemplates/Loader.jsx');
require('./components/LegacyReactTemplates/inputWrappers.jsx');
